<div class="relative w-full" [style.height.px]="height()">
  <div
    echarts
    class="w-full h-full transition-opacity duration-300"
    [class.opacity-0]="loading()"
    [class.opacity-100]="!loading()"
    [options]="options()"
    (chartInit)="onChartInit($event)"
    (chartClick)="onChartClick($event)"
  ></div>

  @if (loading()) {
    <!-- `absolute inset-0` sizes this exactly like the real chart canvas above (both are
         positioned against the same `.relative` container), instead of going through an
         intermediate `flex items-center justify-center` wrapper - that extra layer left the
         skeleton's actual rendered width dependent on how `<ngx-skeleton-loader>` (an unstyled
         custom element, `display: inline` by default) participates in the flex layout, which
         doesn't reliably match the canvas div's own plain `w-full h-full` box. `block` forces
         the host itself out of its default inline display so `width`/`height: 100%` in the
         theme resolve against this element's own box - not an indeterminate shrink-to-fit one -
         and `100%`/`100%` (rather than a fixed px guess) then always matches the canvas exactly,
         including on resize. -->
    <ngx-skeleton-loader
      class="absolute inset-0 block w-full"
      [theme]="{ width: '100%', height: '100%', 'border-radius': '4px' }"
    />
  }
</div>
